<div class="outerBtn" (click)="emitSelection(imageType)">
    <div class="btnTitle" [ngClass]="{'small': smallMode}">
        {{ displayName.replace(underscore, ' ') }}
    </div>
    <div class="browseText" [ngClass]="{'small': smallMode}">
        <i class="far fa-search"></i>
        {{ browseText }}
    </div>
    <div class="innerBtn" [ngClass]="{'active': selected || imageType.selected, 'small': smallMode}">
        <div 
        [style.backgroundPosition]="cssBgPosition + cssBgPosPercent"
        [style.backgroundSize]="cssBgSize"
        [style.backgroundImage]="'url(' + cssBgImagePath + ')'"
         class="partialBtn">
         <i *ngIf="selected || imageType.selected" class="fal fa-check fa-7x selectIcon"></i>
        </div>
    </div>
</div>